import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import Skeleton from 'ui/shared/chakra/Skeleton';

interface Props {
  status: string;
  isLoading?: boolean;
}

const FinanceStatusTag = ({ status, isLoading }: Props) => {
  return (
    <Skeleton isLoaded={ !isLoading } display="inline-flex">
      <Flex
        display="inline-flex"
        alignItems="center"
        gap="4px"
        bg="rgba(20, 220, 172, 0.1)"
        borderRadius="2px"
        px="4px"
        py="2px"
        h="16px"
      >
        <Box
          w="6px"
          h="6px"
          borderRadius="full"
          bg="#14DCAC"
          flexShrink={ 0 }
        />
        <Box
          as="span"
          fontSize="12px"
          fontWeight={ 400 }
          color="#14DCAC"
          lineHeight="1"
          whiteSpace="nowrap"
        >
          { status }
        </Box>
      </Flex>
    </Skeleton>
  );
};

export default FinanceStatusTag;
